// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1bBeW","content":"LayoutSettings_content__352c4"};